module.exports = __webpack_public_path__ + "img/thumbnail_Markhor_f_normal.50cb3c67.png";